import { RouteGroup } from '@/modules/core/app/constants/api.constants';
import { BaseDataResource } from '@/modules/core/app/resources/BaseDataResource';
import { GenericModel } from '@/modules/core/app/models/GenericModel';
import { DISTINCT_VALUES } from '@/modules/ta/widget/widget.constants';

export class GoalDataResource extends BaseDataResource {
  constructor() {
    super(RouteGroup.GOALS_DATA);
  }

  /**
   * @override
   *
   * @param serviceId
   * @param dataViewId
   * @param params
   * @returns {Promise<ApiColumn[]>}
   * */
  async getColumns(serviceId, dataViewId, params = {}) {
    params = { ...params, is_hidden: false };
    return super.getColumns(null, params);
  }

  /**
   *
   * @param serviceId
   * @param dataViewId
   * @param fields
   * @param params
   * @returns {Promise<*>}
   */
  async getValuesDistinct(serviceId, dataViewId, fields, params = {}) {
    params = { ...params, fields };
    return super.getDataValues(GenericModel, DISTINCT_VALUES, params);
  }
}

export default new GoalDataResource();
